export default "__VITE_ASSET__BwJI$Q9d__"